export enum ProductSource {
	NewProduct = 'new-product',
	MyProducts = 'my-product',
	PreviousOrder = 'previous-order',
}
